/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Plugins_PrInputs */

const en_fc_cmp_plugins_pr = /** @type {(inputs: Fc_Cmp_Plugins_PrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huge plugin, template and stock ecosystem`)
};

/**
* | output |
* | --- |
* | "Huge plugin, template and stock ecosystem" |
*
* @param {Fc_Cmp_Plugins_PrInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_plugins_pr = /** @type {((inputs?: Fc_Cmp_Plugins_PrInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Plugins_PrInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_plugins_pr(inputs)
});
export { fc_cmp_plugins_pr as "fc.cmp.plugins.pr" }